module.exports = __webpack_public_path__ + "img/individual.dda33fd0.jpg";